import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'

const style = {
  control: (base, state) => ({
    ...base,
    border: 0,
    // This line disable the blue border
    boxShadow: 0,
    '&:hover': {
      border: 0,
    },
  }),
}

export default function DropdownSelect(props) {
    const {selectedOption, handleSelect, options, isDisabled, placeholder, defaultSelect, modifier, dataTestId} =
      props

    const dropdownSelectModifier = modifier ? ` dropdownSelect__${modifier}` : ''

    return (
      <div data-testid={dataTestId ? dataTestId : 'react-select'} className="dropdownSelect-wrapper">
        <Select
          styles={style}
          className={`dropdownSelect${dropdownSelectModifier}`}
          classNamePrefix="dropdownSelect"
          defaultValue={defaultSelect}
          value={selectedOption}
          onChange={handleSelect}
          options={options}
          isDisabled={isDisabled}
          isSearchable={false}
          placeholder={placeholder}
        />
      </div>
    )
}

DropdownSelect.propTypes = {
  selectedOption: PropTypes.object,
  defaultSelect: PropTypes.object,
  handleSelect: PropTypes.func,
  options: PropTypes.array,
  isDisabled: PropTypes.bool,
  placeholder: PropTypes.string,
  modifier: PropTypes.string,
}
